import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { helpers, time } from "services";
import dayjs from "dayjs";
import DateFilter from "components/DateFilter";
import useTranslation from "hooks/useTranslation";
import { useDispatch, useSelector } from "react-redux";
import Actions from "modules/entity/actions";
import { get } from "lodash";
import ResponsiveApexContainer from "components/ResponsiveApexContainer";

const SalesByDay = () => {
	const { tr } = useTranslation();

	const [salesByDay, setSalesByDay] = useState([]);
	const dispatch = useDispatch();
	const authStore = useSelector(state => state.auth);
	const activeOrganization = get(authStore, "activeOrganization");
	const isMainOrganization = get(authStore, "is_main_organization", false);
	const [startAt, setStartAt] = useState(
		dayjs()
			.startOf("month")
			.unix()
	);
	const [endAt, setEndAt] = useState(
		dayjs()
			.endOf("month")
			.unix()
	);

	const series = salesByDay.map(item => Number(item.sum));
	const categories = salesByDay.map(item => {
		try {
			return dayjs(item.date).format("YYYY-MM-DD");
		} catch (error) {
			return "-";
		}
	});

	useEffect(() => {
		loadSalesByDay(activeOrganization);
	}, [startAt, endAt, activeOrganization]);

	const loadSalesByDay = (orgId = null) => {
		dispatch(
			Actions.LoadDefault.request({
				url: isMainOrganization
					? "/main/dashboard/sales-by-day"
					: "/dashboard/sales-by-day",
				params: {
					extra: {
						start_at: startAt,
						end_at: endAt,
						...(orgId ? { organization_id: orgId } : {})
					}
				},
				cb: {
					success: data => setSalesByDay(data),
					error: () => { }
				}
			})
		);
	};

	const start = dayjs()
		.startOf("month")
		.unix();
	const end = dayjs()
		.endOf("month")
		.unix();

	const handleClick = (start, end) => {
		setStartAt(start);
		setEndAt(end);
	};

	return (
		<div className="dashboard-panel flex-1 mb-10">
			<div className="dashboard-panel__head">
				<div className="d-flex align-items-start justify-content-between">
					<div>
						{tr("Продажи по дням")}: {time.to(start)} - {time.to(end)}
					</div>
					<DateFilter
						dropdownPosition={"right"}
						initialValueQuery={{
							startOf: startAt,
							endOf: endAt
						}}
						handleClick={handleClick}
					/>
				</div>
			</div>
			<div className="dashboard-panel__body pb-0">
				<ResponsiveApexContainer height={350}>
					{chartWidth => (
						<Chart
							options={{
								tooltip: {
									shared: true,
									intersect: false
								},
								chart: {
									id: "chart-top-sale",
									toolbar: {
										show: false
									}
								},
								xaxis: {
									labels: {
										formatter: function (value) {
											return value;
										},
										style: {
											colors: ["#005ff7"],
											fontSize: "10px"
										}
									},
									categories: categories
								},
								yaxis: {
									labels: {
										formatter: function (value) {
											return helpers.convertToReadable(value);
										}
									}
								},
								grid: {
									padding: {
										top: 0,
										left: 0,
										right: 0,
										bottom: 0
									}
								},
								colors: [
									function ({ value }) {
										return `rgba(7,184,170,1)`;
									}
								],
								dataLabels: {
									enabled: false
								}
							}}
							series={[
								{
									name: tr("Продажа"),
									data: series
								}
							]}
							type="bar"
							width={chartWidth}
							height="350"
						/>
					)}
				</ResponsiveApexContainer>
			</div>
		</div>
	);
};

export default SalesByDay;
